export default Backbone.View.extend({
  events: {
    'click .js-filter-subcategory-select-all': 'selectAll',
    'click .js-filter-subcategory-collapse': 'collapse',
  },

  initialize(options) {
    this.$('.js-filter-subcategory-body').collapse();
  },

  selectAll() {
    const allChecked = _.all(this.$('.js-search-advanced-filter-checkbox input'), checkbox =>
      $(checkbox).prop('checked')
    );

    _.each(this.$('.js-search-advanced-filter-checkbox input'), checkbox => {
      $(checkbox)
        .prop('checked', allChecked === false)
        .trigger('change');
    });
  },

  collapse() {
    this.$('.js-subcategory-collapse-icon').toggleClass(
      'rover-icon rover-icon-in-down rover-icon rover-icon-in-right'
    );
    this.$('.js-filter-subcategory-body').collapse('toggle');
  },
});



// WEBPACK FOOTER //
// ./js/backbone/views/search/advanced_filter_subcategory_view.js